import React from 'react'
import { ItemPedidosNegados } from './ItemPedidosNegados'

export const ListaPedidosNegados = ({ lista }) => {
  if (!lista) return null

  return lista?.map((pedido) => <ItemPedidosNegados key={pedido.numero_pedido} pedido={pedido} />)
}
